module.exports = __webpack_public_path__ + "img/3_120.0c455071.png";